import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import TotalNails, { PricingPage } from "./pages/TotalNails/TotalNails";
import classes from "./App.module.css";

function App() {
  return (
    <div className={classes.App}>
      <Routes>
        <Route path="/" element={<TotalNails />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
